var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.$emit('update:status', null)}}},[_vm._v(" BACK ")])])}
var staticRenderFns = []

export { render, staticRenderFns }